import styled, { css } from 'styled-components'

import Media from 'builder/styles/media'
import Icon from 'builder/components/Icon'
import Colors from 'builder/styles/colors'
import Shadows from 'builder/styles/shadows'
import Typography, { FontWeights } from 'builder/styles/typography'

import AAIcon from '../assets/auto-apply.svg'

const getColorsByScore = (score: number) => {
  const isGood = score > 70
  const isAverage = score > 30

  return css`
    background: ${isGood ? Colors.Green10 : isAverage ? Colors.Amber10 : Colors.Red10};
    color: ${isGood ? Colors.Green40 : isAverage ? Colors.Amber40 : Colors.Red40};

    &:hover {
      background: ${isGood ? Colors.Green20 : isAverage ? Colors.Amber20 : Colors.Red20};
    }
  `
}

export const Container = styled.div`
  display: flex;
  gap: 12px;
  padding: 24px;
  border-radius: 12px;
  border: 1px solid ${Colors.Neutral15};
  cursor: pointer;

  &:hover {
    ${Shadows.lightWithBorder.mid};
  }

  ${Media.Phone`
    padding: 20px;
  `}
`

export const LogoContainer = styled.div`
  display: flex;
  width: fit-content;
`

export const Logo = styled.div<{ src?: string }>`
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  width: 48px;
  height: 48px;
  background-image: url(${p => `"${p.src}"`});
  background-position: center center;
  background-size: contain;
`

export const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  ${Media.Phone`
    gap: 10px;
  `}
`

export const JobContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
  flex: 1;
`

export const JobTitle = styled.p`
  ${Typography.Body}
  ${FontWeights.Medium}

  color: ${Colors.Neutral90};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const JobSubTitle = styled.p`
  ${Typography.Body}
  ${FontWeights.Regular}

  color: ${Colors.Neutral80};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const JobInfoContainer = styled.div`
  display: flex;
  gap: 4px;
  align-items: center;
`

export const ListedDate = styled.p`
  ${Typography.Body}
  ${FontWeights.Regular}

  color: ${Colors.Neutral50};
`

export const AutoApplyContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

export const AutoApplyIcon = styled.div`
  width: 26px;
  height: 26px;
  background-image: url(${AAIcon});
`

export const AutoApplyText = styled.p`
  ${Typography.Body}
  ${FontWeights.Regular}

  color: ${Colors.Neutral90};
`

export const ActionContainer = styled.div`
  display: flex;
  gap: 12px;
  margin-left: auto;
  min-width: 130px;

  ${Media.Phone`
    min-width: 85px;
  `}
`

export const Score = styled.div<{ score: number }>`
  display: flex;
  height: fit-content;
  padding: 2px 8px 2px 6px;
  align-items: center;
  gap: 4px;
  border-radius: 4px;

  ${Typography.Caption}
  ${FontWeights.Medium}

  ${({ score }) => getColorsByScore(score)}

  &:before {
    content: '${({ score }) => score}%';
  }
`

export const HeartIcon = styled(Icon.Like)`
  color: ${Colors.Neutral40};
`

export const HeartIconFilled = styled(Icon.LikeFilled)`
  color: ${Colors.Red50};
`

export const ActionButton = styled.div`
  width: 32px;
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  position: relative;
  transition: all 0.1s ease;
  background: transparent;
  border-radius: 8px;
  position: relative;
  top: -4px;

  &:hover {
    background: ${Colors.Neutral5};

    ${HeartIconFilled} {
      color: ${Colors.Red60};
    }
  }
`
